import styled from 'styled-components';

export const UploaderWrap = styled.div`
  min-width: 0;
`;

export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);
`;

export const PreviewItem = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--bg-input);
  border: 1px solid var(--border-light);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    opacity: ${props => (props.$uploading ? 0.45 : 1)};
  }
`;

export const CoverBadge = styled.span`
  position: absolute;
  left: 6px;
  bottom: 6px;
  background: var(--primary);
  color: var(--white);
  font-size: var(--text-xs);
  font-weight: 700;
  padding: 2px 8px;
  border-radius: var(--radius-round);
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: var(--bg-overlay-strong);
  color: var(--white);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover { background: var(--danger); }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

export const Spinner = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--primary-dark);
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  max-width: 100%;
  padding: 0 18px;
  border-radius: var(--radius-round);
  border: 1.5px dashed var(--primary);
  background: var(--primary-subtle);
  color: var(--primary);
  font-family: var(--font-brand);
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Hint = styled.small`
  display: block;
  margin-top: var(--spacing-xs);
  color: var(--text-muted);
  font-size: var(--text-xs);
`;

export const ErrorText = styled.p`
  margin-top: var(--spacing-sm);
  color: var(--danger-dark);
  font-size: var(--text-sm);
`;
